import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CookieService} from 'ngx-cookie-service';
import {ApiService} from '../../service/api.service';
import {PermissionService} from '../../service/permission.service';
import {UserTypeService} from '../../service/user-type.service';
import {keys} from '../../shared/constants';

@Component({
  selector: 'invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.scss']
})
export class InviteComponent implements OnInit {

  error = '';
  loading = false;
  submitted = false;
  formGroup: FormGroup;

  constructor(private apiService: ApiService,
              private formBuilder: FormBuilder,
              private userTypeService: UserTypeService,
              private permissionService: PermissionService,
              private cookieService: CookieService) {
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      email: ['', Validators.required],
      types: ['', Validators.required],
      permissions: ['', Validators.required]
    });
  }

  get fg() {
    return this.formGroup.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    this.loading = true;

    let _this = this;
    this.apiService.send({
      command: 'invite',
      request: {
        email: this.fg.email.value,
        typeIds: this.fg.types.value,
        permissionIds: this.fg.permissions.value,
        projectId: this.cookieService.get(keys.project)
      }
    }, (response, headers) => {
      response = response.response;
      if (!response.error) {
        return;
      }

      _this.fg.email.enable();
      _this.error = response.error.message;
      _this.loading = false;
    });
  }
}
